var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('b-navbar',{attrs:{"type":"is-warning","fixed-top":"","mobile-burger":false},scopedSlots:_vm._u([{key:"brand",fn:function(){return [_c('b-navbar-item',{attrs:{"to":{ path: '/' }}},[_c('img',{attrs:{"src":require('@/assets/logo-letras_negras.png')}})])]},proxy:true}])}),_c('FracttalQuery')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }